module.exports = __webpack_public_path__ + "static/media/ImportTemplate.8c023b06.csv";